import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import "../css/ChatRoomModal.css";

const ChatRoomModal = (props) => {
  const {
    currentChatRoom,
    offerPrice,
    reviewText,
    reviewStar,

    setOfferPrice,
    setReviewText,
    setReviewStar,

    handleNewOffer,
    handleCancelOffer,
    handleRejectOffer,
    handleAcceptOffer,
    handleWriteReview,
    handleReserve,
    handleSoldOut,

    reviewTextError,
    offerError,

    showOfferModal,
    setShowOfferModal,
    showCancelOfferModal,
    setShowCancelOfferModal,
    showRejectOfferModal,
    setShowRejectOfferModal,
    showAcceptOfferModal,
    setShowAcceptOfferModal,
    showWriteReviewModal,
    setShowWriteReviewModal,
    showReserveModal,
    setShowReserveModal,
    showSoldOutModal,
    setShowSoldOutModal,
    showWarningModal,
    setShowWarningModal,
  } = props;

  return (
    <>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showOfferModal}
        onHide={() => {
          setShowOfferModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>我要出價</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          出價 HK$
          <Form.Control
            type="number"
            placeholder="出價"
            value={offerPrice}
            onChange={(e) => setOfferPrice(e.target.value)}
          />
          {offerError && (
            <Form.Label className="masterError">{offerError}</Form.Label>
          )}
          <br />
          請緊記，如果對方接受你的出價後，即表示此商品已成交。賣買雙方均有責任完成此交易，同時買賣雙方可以就此成交作出交易評價。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowOfferModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleNewOffer();
            }}
          >
            立即出價
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showCancelOfferModal}
        onHide={() => {
          setShowCancelOfferModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>取消出價</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          現在出價： ${currentChatRoom?.lastOffer?.offeredPrice}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCancelOfferModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleCancelOffer(currentChatRoom?.lastOffer?.offeredPrice);
            }}
          >
            取消出價
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showRejectOfferModal}
        onHide={() => {
          setShowRejectOfferModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>拒絕出價</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          現在出價： ${currentChatRoom?.lastOffer?.offeredPrice}
          <br />
          除了拒絕對方的出價外，你可以還對方一口價，促成交易。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowRejectOfferModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleRejectOffer(currentChatRoom?.lastOffer?.offeredPrice);
            }}
          >
            拒絕出價
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showAcceptOfferModal}
        onHide={() => {
          setShowAcceptOfferModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>接受出價</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          現在出價： ${currentChatRoom?.lastOffer?.offeredPrice}
          <br />
          請緊記，你接受對方的出價後，即表示此商品已成交。雙方可以就此成交作出交易評價。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowAcceptOfferModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleAcceptOffer(currentChatRoom?.lastOffer?.offeredPrice);
            }}
          >
            接受出價
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Write Review Modal */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showWriteReviewModal}
        onHide={() => {
          setShowWriteReviewModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>寫交易評價</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {reviewTextError && (
            <Form.Label className="masterError">{reviewTextError}</Form.Label>
          )}
          <Form.Control
            placeholder="交易評價"
            value={reviewText}
            as="textarea"
            forws={3}
            onChange={(e) => setReviewText(e.target.value)}
          />
          <div className="modalStarRatingWrap">
            <div className="modalStarRatingTitle">整體評分</div>
            <ReactStars
              count={5}
              value={reviewStar}
              onChange={setReviewStar}
              size={30}
              activeColor="#ffd700"
              style={{ marginTop: 0 }}
            />
          </div>
          <br />
          交易評價一經提交是不能更改的。如果你對交易有異議，請先向對方提出交涉，尋求一個可行及雙贏的方案。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowWriteReviewModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleWriteReview();
            }}
          >
            提交評價
          </Button>
        </Modal.Footer>
      </Modal>

      {/* mark as reserve Modal */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showReserveModal}
        onHide={() => {
          setShowReserveModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>設定為已保留</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          物品設定為已保留後，會被暫停顯示。日後你可以取消物品的「已保留」狀態，重新顯示該物品及接受出價。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowReserveModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleReserve();
            }}
          >
            設定為已保留
          </Button>
        </Modal.Footer>
      </Modal>

      {/* mark as soldout modal */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showSoldOutModal}
        onHide={() => {
          setShowSoldOutModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>設定為已售完</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          請確定此物品已售完。當物品被設定為「已售完」後，物品會被停止顯示及下架。
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowSoldOutModal(false);
            }}
          >
            關閉
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleSoldOut();
            }}
          >
            設定為已售完
          </Button>
        </Modal.Footer>
      </Modal>

      {/* show popup dialog to user */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showWarningModal}
        onHide={() => {
          setShowWarningModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>Warning Text</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowWarningModal(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChatRoomModal;
